// no-export
export const CACHE_CONTROL_HEADER_KEY: string = 'cache-control';
export const CONTENT_TYPE_HEADER_KEY: string = 'content-type';
// pseudo-header injected after response received with current local timestamp; used for auto refresh
export const LOCAL_TIMESTAMP_HEADER_KEY: string = '__Local_Timestamp';
